import React, { useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const PRESETS = ["25", "50", "100"];

export const GiftVoucherPanel = () => {
  const [amountOption, setAmountOption] = useState("50");
  const [customAmount, setCustomAmount] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [senderName, setSenderName] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const buy = async () => {
    if (!recipientEmail.includes("@")) { toast.error("Enter the recipient's email address"); return; }
    if (amountOption === "custom" && !(Number(customAmount) >= 5)) { toast.error("Custom amount must be at least $5"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/payments/gift-checkout", {
        amount_option: amountOption,
        custom_amount: amountOption === "custom" ? Number(customAmount) : null,
        recipient_name: recipientName,
        recipient_email: recipientEmail,
        sender_name: senderName,
        message,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not start the gift checkout");
      setBusy(false);
    }
  };

  return (
    <div data-testid="gift-voucher-panel">
      <h3 className="font-serif-display uppercase text-plum-deep text-xl md:text-2xl tracking-[0.08em] flex items-center gap-3">
        <span className="w-9 h-9 rounded-full bg-lemon text-plum-deep flex items-center justify-center shrink-0"><Gift className="w-4 h-4" /></span>
        GIFT A VOUCHER
      </h3>
      <div className="mt-5 bg-plum rounded-3xl p-6 text-cream">
        <p className="text-sm text-cream/80">Send a friend Bloom Foundry credit — we email them the code the moment your payment goes through. Unused credit stays on the code for next time.</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {PRESETS.map((p) => (
            <button
              key={p}
              onClick={() => setAmountOption(p)}
              data-testid={`gift-amount-${p}`}
              className={`px-5 py-2.5 rounded-full text-sm font-serif-display font-bold tracking-[0.1em] transition-colors ${amountOption === p ? "bg-lemon text-plum-deep" : "bg-cream/10 text-cream hover:bg-cream/20"}`}
            >
              ${p}
            </button>
          ))}
          <button
            onClick={() => setAmountOption("custom")}
            data-testid="gift-amount-custom"
            className={`px-5 py-2.5 rounded-full text-sm font-serif-display font-bold tracking-[0.1em] transition-colors ${amountOption === "custom" ? "bg-lemon text-plum-deep" : "bg-cream/10 text-cream hover:bg-cream/20"}`}
          >
            CUSTOM
          </button>
          {amountOption === "custom" && (
            <input
              type="number" min="5" max="500" value={customAmount}
              onChange={(e) => setCustomAmount(e.target.value)}
              placeholder="$"
              data-testid="gift-custom-amount"
              className="w-24 rounded-full px-4 py-2 bg-cream text-plum-deep text-sm focus:outline-none"
            />
          )}
        </div>
        <div className="mt-4 grid sm:grid-cols-2 gap-3">
          <input value={recipientName} onChange={(e) => setRecipientName(e.target.value)} placeholder="Friend's name" data-testid="gift-recipient-name" className="rounded-full px-5 py-3 bg-cream text-plum-deep text-sm placeholder:text-plum-deep/50 focus:outline-none" />
          <input type="email" value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} placeholder="Friend's email *" data-testid="gift-recipient-email" className="rounded-full px-5 py-3 bg-cream text-plum-deep text-sm placeholder:text-plum-deep/50 focus:outline-none" />
          <input value={senderName} onChange={(e) => setSenderName(e.target.value)} placeholder="Your name" data-testid="gift-sender-name" className="rounded-full px-5 py-3 bg-cream text-plum-deep text-sm placeholder:text-plum-deep/50 focus:outline-none" />
          <input value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Gift message (optional)" data-testid="gift-message" className="rounded-full px-5 py-3 bg-cream text-plum-deep text-sm placeholder:text-plum-deep/50 focus:outline-none" />
        </div>
        <button
          onClick={buy}
          disabled={busy}
          data-testid="gift-buy-btn"
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-lemon text-plum-deep px-7 py-3.5 font-serif-display uppercase text-xs tracking-[0.18em] font-bold hover:bg-cream transition-colors disabled:opacity-50"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Gift className="w-4 h-4" />}
          BUY GIFT VOUCHER
        </button>
        <p className="mt-2 text-[11px] text-cream/50 uppercase tracking-[0.12em]">PAID SECURELY BY CARD — THE CODE IS EMAILED INSTANTLY AFTER PAYMENT</p>
      </div>
    </div>
  );
};
